import PropTypes from 'prop-types';
import React from 'react';

import {EventContentVariantPopup} from '@utils/eventContentVariant/EventContentVariantPopup';

export const EventWatermarkingContentLabel = ({eventContent}) => {
    return (
        <>
            {eventContent.view_name}
            <EventContentVariantPopup eventContentVariant={eventContent.event_content_variant}/>
        </>
    );
};

EventWatermarkingContentLabel.propTypes = {
    eventContent: PropTypes.shape({
        view_name: PropTypes.string,
        event_content_variant: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            short_name: PropTypes.string,
        }),
    }),
};
